(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('itemsPerPage', {
            templateUrl: 'app/components/items-per-page/items-per-page.html',
            controller: itemsPerPageController,
            bindings: {
                name: '@',
                placeholder: '@',
                options: '<',
                onChange: '&',
                value: '=',
            }
        })
        .directive("changeItemsPerPage", function () {
            return {
                restrict: "A",
                link: function (scope) {
                    scope.$watch("$ctrl.value", function (newValue) {
                        if (scope.$ctrl.onChange) {
                            scope.$ctrl.onChange({ newValue: newValue });
                        }
                    });
                },
            };
        });

    /** @ngInject */
    function itemsPerPageController($translate, $window, $scope, systemConstants) {
        var $ctrl = this;

        $ctrl.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MIN_SM;

        $ctrl.$onInit = function () {
            $ctrl.selectedOption = findOption($ctrl.value) || ($ctrl.options && $ctrl.options[0]);

            if ($ctrl.selectedOption) {
                $ctrl.onChange({ newValue: $ctrl.selectedOption.value });
            }

            getIsMobileValue();
        };

        function getIsMobileValue() {
            $ctrl.isMobile = $window.innerWidth <= 768;
        }

        angular.element($window).on('resize', function () {
            $scope.$apply(getIsMobileValue);
        });

        $ctrl.getButtonLabel = function () {
            if ($ctrl.placeholder) {
                return $translate.instant($ctrl.placeholder, { items: $ctrl.selectedOption.label });
            }
            return $translate.instant('flyers.list.itemsPerPage', { items: $ctrl.selectedOption.label });
        };

        $ctrl.getHeaderText = function () {
            return $translate.instant('flyers.list.pagination');
        };

        $ctrl.selectOption = function (option) {
            $ctrl.selectedOption = option;
            $ctrl.onChange({ newValue: option.value });
        };

        function findOption(value) {
            if (!$ctrl.options) return null;
            for (var i = 0; i < $ctrl.options.length; i++) {
                if ($ctrl.options[i].value === value) {
                    return $ctrl.options[i];
                }
            }
            return null;
        }
        $ctrl.isSelected = function (option) {
            return $ctrl.selectedOption && $ctrl.selectedOption.value === option.value;
        };
    }
})();
